import { TenantLogoOrLottie } from "./tenant-logo-or-lottie";
import { TextFadeAnimation } from "./text-fade";

export const AuthLoadingScreen = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <TenantLogoOrLottie />
      <TextFadeAnimation text="Just making sure you're signed in…" />
    </div>
  );
};

export default AuthLoadingScreen;
